import Swiper from 'swiper/bundle';
import ProgressBar from 'progressbar.js/dist/progressbar.js';
//トップページ キービジュアルスライダー
export function idxFunc() {
  if ($('#indexTop').length) {
//    var Gradient = '<defs><linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#1e5799"/><stop offset="50%" stop-color="#2989d8"/><stop offset="100%" stop-color="#7db9e8"/></linearGradient></defs>';
//    var bar = new ProgressBar.Line('#ProgressBar', {
//      strokeWidth: 4,
//      easing: 'easeInOut',
//      duration: 1000,
//      color: 'url(#gradient)',
//      trailColor: '#eee',
//      trailWidth: 1,
//      svgStyle: {
//        width: '100%',
//        height: '100%'
//      },
//      text: {
//        style: {
//          padding: 0,
//          margin: 0,
//          transform: null
//        },
//        autoStyleContainer: false
//      },
//      from: {
//        color: '#FFEA82'
//      },
//      to: {
//        color: '#ED6A5A'
//      },
//      step: (state, bar) => {
//        bar.setText(Math.round(bar.value() * 100) + ' %');
//      }
//    });
//    bar.svg.insertAdjacentHTML('afterbegin', Gradient);
//    bar.animate(1.0, function () {
//      var loading = $('#jsLoader');
//      loading.fadeOut(800);
//      $(window).on('load', stopload);
//      /* 10秒経ったら強制的にローディング画面を非表示にする */
//      setTimeout('stopload()', 10000);
//
//      /* ローディング画面を非表示にする処理 */
//      function stopload() {
//        loading.fadeOut(800);
//      }
//    });
  }
}

export function pickupFunc() {
  var topSwiper, topOptions;
  topSwiper = undefined;
  topOptions = {
    freeMode: true,
    slidesPerView: 2.2,
    spaceBetween: 12,
    mousewheel: {
      forceToAxis: true,
      invert: false
    },
    navigation: {
      nextEl: '.pickupNext',
      prevEl: '.pickupPrev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 12
      }
    }
  };
  //スワイプ実行処理
  function initTopSwiper() {
    topSwiper = new Swiper('#pickupJs', topOptions);
  }
  initTopSwiper();
}

export function mvFunc() {
  var topSwiper, topOptions;
  var bar = document.querySelector('.bar');
  var barDuration = 5000;
  topSwiper = undefined;
  topOptions = {
    loop: true,
    speed: 800,
    slidesPerView: 1,
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 5000, //初期値3000
      disableOnInteraction: false,
    }
  };
  //スワイプ実行処理
  function initTopSwiper() {
    topSwiper = new Swiper('#mvJs', topOptions);
  }
  initTopSwiper();
}

export function serviceFunc() {
  $(document).ready(function () {

    var mCount = $('.mListBox li').length;
    var mThisCount = 1;
    var clickCut = 0;

    //work navi button
    $('.mNav li').click(function () {
      if (clickCut == 0) {
        clickCut = 1;
        var index = $('.mNav li').index(this);
        $('#work').removeClass();
        if (index == 0) {
          if (mThisCount < mCount) {
            mThisCount++;
          } else {
            mThisCount = 1;
          }
        } else if (index == 1) {
          if (mThisCount > 1) {
            mThisCount--;
          } else {
            mThisCount = mCount;
          }
        }

        $('.mImgBox li').css({
          'z-index': ''
        });
        $('.mImgBox li').eq(mThisCount - 1).css({
          'z-index': '1'
        });
        $('.mImgBox li').eq(mThisCount - 2).css({
          'z-index': '2'
        });
        $('.mImgBox li').eq(mThisCount - 3).css({
          'z-index': '3'
        });
        $('.mImgBox li').eq(mThisCount - 4).css({
          'z-index': '4'
        });
        $('.mImgBox li').eq(mThisCount - 5).css({
          'z-index': '5'
        });
        $('.mImgBox li').eq(mThisCount - 6).css({
          'z-index': '6'
        });

        $('#work').addClass('m' + mThisCount);
        $('#work').addClass('d' + index);

        setTimeout(function () {
          clickCut = 0;
        }, 1000);
      }
      return false;
    });

    //resize - work image
    $(window).resize(function () {
      workImgSize();
    });
    workImgSize();
  });

  function workImgSize() {
    $('.mImgBox li').css({
      'background-size': $('.mImgBox').width() + 'px auto'
    });
  }
}